import { inject } from '@angular/core';
import { ModalService, translator } from '@softline/ui-core';
import { EinheitAuswahlItem } from '../../types/einheit-auswahl-item';
import { SelectUnitDialog } from './select-unit.dialog';

export function openSelectUnitDialog() {
  const modalService = inject(ModalService);
  const t = translator();
  return async (units: EinheitAuswahlItem[]): Promise<EinheitAuswahlItem | 'DISMISSED'> => {
    return (await modalService.open({
      component: SelectUnitDialog,
      title: t('#LAGERPLATZ_CORE.DIALOGS.SELECT_UNIT.TITLE'),
      data: { units },
    })) as EinheitAuswahlItem | 'DISMISSED';
  };
}
